module.exports = __webpack_public_path__ + "img/your_story.37adec00.png";